import { CurrencyInput } from 'src/common/CurrencyInput';
import { NumberRangeValue } from 'src/common/primitives/NumberRangeFilterPopover/NumberRangeFilterPopover';

export function PriceFilter({
  selectedPrice,
  onPriceChange,
  dataTestId,
}: {
  selectedPrice: NumberRangeValue | null;
  onPriceChange: (price: NumberRangeValue | null) => void;
  dataTestId: string;
}) {
  const updatePrice = (patch: Partial<NumberRangeValue>) => {
    const next: NumberRangeValue = { ...(selectedPrice ?? {}), ...patch };

    const hasMin = next.min !== undefined && !isNaN(next.min);
    const hasMax = next.max !== undefined && !isNaN(next.max);

    onPriceChange(hasMin || hasMax ? next : null);
  };

  return (
    <div className="flex flex-col gap-2" data-testid={dataTestId}>
      <label className="flex flex-col text-sm font-medium text-gray-700">
        Min Price
        <CurrencyInput
          data-testid={`${dataTestId}-min`}
          value={selectedPrice?.min}
          onValueChange={({ floatValue }) => {
            updatePrice({ min: floatValue });
          }}
        />
      </label>
      <label className="flex flex-col text-sm font-medium text-gray-700">
        Max Price
        <CurrencyInput
          data-testid={`${dataTestId}-max`}
          value={selectedPrice?.max}
          onValueChange={({ floatValue }) => {
            updatePrice({ max: floatValue });
          }}
        />
      </label>
    </div>
  );
}
